const ns = {};

ns.NavigationHelper = function (navigationRoute) {
    this.navigationRoute = navigationRoute;
};

/**
 * Berechnet eine URI zur History-basierten Navigation.
 *
 * @param {String} from Seite, die in der History gespeichert werden soll
 * @param {String} to Seite, zu der die URI leiten soll
 * @returns {String}
 */
ns.NavigationHelper.prototype.uri = function (from, to) {
    return this.navigationRoute + '?from=' + encodeURIComponent(from)
             + '&to=' + encodeURIComponent(to);
};

/**
 * Wie uri(), jedoch wird die Weiterleitung direkt ausgefuehrt.
 *
 * @param {String} from
 * @param {String} to
 */
ns.NavigationHelper.prototype.redirect = function (from, to) {
    var uri = this.uri(from, to);
    location.href = uri;
};

/**
 * Ruft die zuletzt in der Session gespeicherte Seite auf.
 */
ns.NavigationHelper.prototype.back = function () {
    location.href = this.navigationRoute + '/back';
};

export default ns.NavigationHelper;
